import React from 'react'
import { Oscar } from '../../collections/Oscar/Oscar'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from '../../collections/collections-props.routing'
import { Section } from '../../__styling/settings/sections'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { ResponsiveContainer } from '../../content/Picture/responsive'

export interface OscarRouteProps
    extends CollectionRouteProps,
        ResponsiveContainer {
    collectionSection: Section
    disableImageLazyLoad?: boolean
    heroCardType?: 'portrait' | 'landscape-stacked'
    hasSeparators?: boolean
    truncatedListCards?: boolean
    relatedLinks?: {
        title: string
        links: Array<{ text: string; link: string }>
    }
}

export const OscarRegistration = createRegisterableComponentWithData(
    'oscar',
    ContentDataDefinitionLoader,
    (props: OscarRouteProps, data, services) => {
        return (
            <Oscar
                items={
                    data.loaded
                        ? { loaded: true, result: data.result.publications }
                        : { loaded: false }
                }
                sectionHeader={props.sectionHeader}
                verticalSpacing={props.verticalSpacing}
                disableImageLazyLoad={props.disableImageLazyLoad}
                hasSeparators={props.hasSeparators}
                onEvent={services.onEvent}
                expectedCards={calculateExpectedCardCountFromContentData(
                    data.dataDefinitionArgs,
                )}
                heroCardType={props.heroCardType || 'landscape-stacked'}
                truncateListCards={props.truncatedListCards}
                relatedLinks={props.relatedLinks}
                containerWidthRatios={props.containerWidthRatios}
            />
        )
    },
)
